/*
 * Regional-language STUDENT certificates for Swachhata Hi Seva (DoSEL
 * translations, received 2026-09-15). Each language is a STANDALONE sheet in
 * the same layout as the English one, with no English beside it:
 *   kicker     → the "Solid Waste Management Rules 2026" pill
 *   titleMain  → the big "CERTIFICATE" line
 *   titleSub   → the "of Participation" line (the supplied title, split)
 *   text       → split at {name}: the words before it are the "This certificate
 *                is presented to" line, the words after it the "for successfully
 *                completing …" line (grammatical suffix — அவர்களுக்கு, কে, ਨੂੰ … — included)
 *   bins       → BINS order: wet, dry, sanitary, special care
 * These are the quiz wording only — school certificates keep en / hi / bi.
 * Kept verbatim; the only edits are markdown asterisks and doubled spaces removed.
 */

const DEVA = '"Noto Sans Devanagari", "Tiro Devanagari Hindi", sans-serif';
const BENG = '"Noto Sans Bengali", sans-serif';

export const CERT_REGIONAL = {
  as: {
    label: "অসমীয়া (Assamese)",
    font: BENG,
    kicker: "কঠিন আৱৰ্জনা ব্যৱস্থাপনা নিয়মাৱলী ২০২৬",
    // supplied title "অংশগ্ৰহণৰ প্ৰমাণপ্ৰত্ৰ", split into the two title lines
    titleMain: "প্ৰমাণপ্ৰত্ৰ",
    titleSub: "অংশগ্ৰহণৰ",
    text: "এই প্ৰমাণপ্ৰত্ৰখন {name} লৈ মিছন লাইফৰ ইকো ক্লাবৰ অধীনত কঠিন আৱৰ্জনা ব্যৱস্থাপনা নিয়মাৱলী ২০২৬ ৰ ওপৰত অনুষ্ঠিত কুইজ প্ৰতিযোগিতাত সফলতাৰে অংশগ্ৰহণ কৰাৰ বাবে আগবঢ়োৱা হ’ল।",
    bins: ["সেমেকা আৱৰ্জনা", "শুকান আৱৰ্জনা", "অনাময় আৱৰ্জনা", "বিশেষ যত্ন ল’বলগীয়া আৱৰ্জনা"],
  },
  bn: {
    label: "বাংলা (Bengali)",
    font: BENG,
    kicker: "কঠিন বর্জ্য ব্যবস্থাপনা বিধিমালা, ২০২৬",
    // supplied title "অংশগ্রহণের শংসাপত্র", split into the two title lines
    titleMain: "শংসাপত্র",
    titleSub: "অংশগ্রহণের",
    text: "এই শংসাপত্রটি {name}-কে মিশন লাইফ-এর জন্য ইকো ক্লাবের উদ্যোগে আয়োজিত 'কঠিন বর্জ্য ব্যবস্থাপনা বিধিমালা, ২০২৬' বিষয়ক কুইজ সফলভাবে সম্পন্ন করার জন্য গর্বের সঙ্গে প্রদান করা হলো।",
    bins: ["ভেজা বর্জ্য", "শুকনো বর্জ্য", "স্যানিটারি বর্জ্য", "বিশেষ যত্নের বর্জ্য"],
  },
  bodo: {
    label: "बर' (Bodo)",
    font: DEVA,
    kicker: "गोख्रों दाखोर-दाला सामलायनाय नेम 2026",
    // supplied title "बाहागो लानायनि फोरमान बिलाइ", split into the two title lines
    titleMain: "फोरमान बिलाइ",
    titleSub: "बाहागो लानायनि",
    text: "बे फोरमानलाइखौ गोग्गानानै {name} नो होनाय जायो, जाय 'मिसन लाइफ' नि सिङाव इक' क्लाबफोरा खुंजानाय 'गोख्रों दाखोर-दाला सामलायनाय नेम 2026' नि सायाव बिथा खालामनानै कुइजखौ जाफुंसारै फोजोबनो हादों।",
    bins: ["गिसि दाखोर", "गोरान दाखोर", "सेनिटारि दाखोर", "जर'खा जोथोन लाग्रा दाखोर"],
  },
  dgo: {
    label: "डोगरी (Dogri)",
    font: DEVA,
    kicker: "ठोस कचरा प्रबंधन नियम 2026",
    // supplied title "भागीदारी प्रमाणपत्र", split into the two title lines
    titleMain: "प्रमाणपत्र",
    titleSub: "भागीदारी",
    text: "एह् प्रमाणपत्र {name} होरें गी मिशन लाइफ लेई इको क्लब दे तैह्त ठोस कचरा प्रबंधन नियम 2026 पर क्विज गी कामयाबी कन्नै पूरा करने लेई गर्व कन्नै भेंट कीता गेआ ऐ।",
    bins: ["गि'ल्ला कूड़ा", "सुक्का कूड़ा", "साफ-सफाई दा कूड़ा", "खास दिक्ख-भाल करने आह्ला कूड़ा"],
  },
  gu: {
    label: "ગુજરાતી (Gujarati)",
    font: '"Noto Sans Gujarati", sans-serif',
    kicker: "બિનઉપયોગી ઘનપદાર્થ વ્યવસ્થાપન નિયમો, ૨૦૨૬",
    // no "Certificate of Participation" was supplied: "પ્રમાણપત્ર" (certificate) is taken from the sentence below
    titleMain: "પ્રમાણપત્ર",
    titleSub: "",
    text: "આ પ્રમાણપત્ર ગૌરવસહ {name}ને ‘મિશન લાઈફ’ અંતર્ગત ઇકો ક્લબના ઉપક્રમે ‘બિનઉપયોગી ઘનપદાર્થ વ્યવસ્થાપન નિયમો, ૨૦૨૬’ અંગેની પ્રશ્નોત્તરી સફળતાપૂર્વક પૂર્ણ કરવા બદલ એનાયત કરવામાં આવે છે.",
    bins: ["ભીનો કચરો", "સૂકો કચરો", "સ્વચ્છતાલક્ષી કચરો", "વિશેષ કાળજીનો કચરો"],
  },
  kn: {
    label: "ಕನ್ನಡ (Kannada)",
    font: '"Noto Sans Kannada", sans-serif',
    kicker: "ಘನತ್ಯಾಜ್ಯ ನಿರ್ವಹಣೆ ನಿಯಮಗಳು 2026",
    // supplied title "ಭಾಗವಹಿಸುವಿಕೆಯ ಪ್ರಮಾಣಪತ್ರ", split into the two title lines
    titleMain: "ಪ್ರಮಾಣಪತ್ರ",
    titleSub: "ಭಾಗವಹಿಸುವಿಕೆಯ",
    text: "ಈ ಪ್ರಮಾಣಪತ್ರವನ್ನು {name} ಅವರಿಗೆ ಈಕೋ ಕ್ಲಬ್ಸ್ ಫಾರ್ ಮಿಷನ್ ಲೈಫ್ ಅಡಿಯಲ್ಲಿ ಘನತ್ಯಾಜ್ಯ ನಿರ್ವಹಣೆ ನಿಯಮಗಳು 2026ರ ಕುರಿತಾದ ರಸಪ್ರಶ್ನೆ ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಯಶಸ್ವಿಯಾಗಿ ಭಾಗವಹಿಸಿ ಪೂರ್ಣಗೊಳಿಸಿದ್ದಕ್ಕಾಗಿ ಹೆಮ್ಮೆಯಿಂದ ನೀಡಲಾಗುತ್ತಿದೆ.",
    bins: ["ಹಸಿ ತ್ಯಾಜ್ಯ", "ಒಣ ತ್ಯಾಜ್ಯ", "ನೈರ್ಮಲ್ಯ ತ್ಯಾಜ್ಯ", "ವಿಶೇಷ ಕಾಳಜಿಯ ತ್ಯಾಜ್ಯ"],
  },
  ml: {
    label: "മലയാളം (Malayalam)",
    font: '"Noto Sans Malayalam", sans-serif',
    kicker: "ഖരമാലിന്യ പരിപാലന നിയമങ്ങൾ 2026",
    // supplied title "പങ്കാളിത്ത സർട്ടിഫിക്കറ്റ്", split into the two title lines
    titleMain: "സർട്ടിഫിക്കറ്റ്",
    titleSub: "പങ്കാളിത്ത",
    text: "ഈ സർട്ടിഫിക്കറ്റ് നൽകുന്നത് {name} മിഷൻ ലൈഫിനായുള്ള ഇക്കോ ക്ലബ്ബുകളുടെ ആഭിമുഖ്യത്തിൽ നടന്ന ഖരമാലിന്യ പരിപാലന നിയമ ക്വിസ് 2026-ൽ വിജയകരമായി പങ്കെടുത്തതിനാണ്.",
    bins: ["ജൈവ മാലിന്യം", "അജൈവ മാലിന്യം", "സാനിട്ടറി മാലിന്യം", "പ്രത്യേക കരുതൽ ആവശ്യമുള്ള മാലിന്യം"],
  },
  mni: {
    label: "ꯃꯩꯇꯩꯂꯣꯟ (Manipuri)",
    font: '"Noto Sans Meetei Mayek", sans-serif',
    kicker: "ꯁꯣꯂꯤꯗ ꯋꯦꯁ ꯃꯦꯅꯦꯖꯃꯦꯟ ꯔꯨꯜ 2026",
    // supplied title "ꯁꯔꯨꯛ ꯌꯥꯕꯒꯤ ꯁꯔꯇꯤꯐꯤꯀꯦꯠ", split into the two title lines
    titleMain: "ꯁꯔꯇꯤꯐꯤꯀꯦꯠ",
    titleSub: "ꯁꯔꯨꯛ ꯌꯥꯕꯒꯤ",
    text: "ꯁꯔꯇꯤꯐꯤꯀꯦꯠ ꯑꯁꯤ ꯏꯀꯣ ꯀ꯭ꯂꯕꯁ ꯐꯣꯔ ꯃꯤꯁꯟ ꯂꯥꯏꯐꯀꯤ ꯃꯈꯥꯗ ꯄꯥꯡꯊꯣꯛꯄ ꯁꯣꯂꯤꯗ ꯋꯦꯁ ꯃꯦꯅꯦꯖꯃꯦꯟ ꯔꯨꯜ 2026 ꯀꯤ ꯀ꯭ꯋꯤꯖ ꯑꯗꯨ ꯃꯥꯏ ꯄꯥꯛꯅ ꯁꯔꯨꯛ ꯌꯥꯈꯤꯕꯒꯤꯗꯃꯛ {name}ꯗ ꯈꯨꯗꯣꯜ ꯇꯝꯈꯤ ꯫",
    bins: ["ꯆꯣꯠ ꯋꯦꯁ", "ꯗ꯭ꯔꯥꯢ ꯋꯦꯁ", "ꯁꯦꯡꯇꯤꯔꯤ ꯋꯦꯁ", "ꯁ꯭ꯄꯦꯁꯤꯌꯦꯜ ꯀꯦꯌꯔ ꯋꯦꯁ"],
  },
  ne: {
    label: "नेपाली (Nepali)",
    font: DEVA,
    kicker: "ठोस फोहोर व्यवस्थापन नियमावली, २०२६",
    // supplied title "सहभागिताको प्रमाणपत्र", split into the two title lines
    titleMain: "प्रमाणपत्र",
    titleSub: "सहभागिताको",
    text: "जीवन अभियानका लागि पर्यावरणीय क्लबहरू (LiFE)को संरक्षणमा सञ्चालित ठोस फोहरमैला व्यवस्थापन नियमावली, २०२६ सम्बन्धी प्रश्नोत्तरी सफलतापूर्वक सम्पन्न गर्नुभएको उपलक्ष्यमा यो प्रमाणपत्र {name} लाई सगौरव प्रदान गरिएको छ।",
    bins: ["भिजेको फोहोर", "सुक्खा फोहोर", "स्वच्छतासम्बन्धी फोहोर", "विशेष सावधानीपूर्वक व्यवस्थापन गर्नुपर्ने फोहोर"],
  },
  or: {
    label: "ଓଡ଼ିଆ (Odia)",
    font: '"Noto Sans Oriya", sans-serif',
    kicker: "କଠିନ ବର୍ଜ୍ୟବସ୍ତୁ ପରିଚାଳନା ନିୟମାବଳୀ 2026",
    // supplied title "ଅଂଶଗ୍ରହଣ ପ୍ରମାଣପତ୍ର", split into the two title lines
    titleMain: "ପ୍ରମାଣପତ୍ର",
    titleSub: "ଅଂଶଗ୍ରହଣ",
    text: "ଏହି ପ୍ରମାଣପତ୍ର ସମ୍ମାନର ସହିତ {name} ଙ୍କୁ 'ମିଶନ୍ ଲାଇଫ୍' ର 'ଇକୋ କ୍ଲବ୍' ଆନୁକୂଲ୍ୟରେ ଆୟୋଜିତ 'କଠିନ ବର୍ଜ୍ୟବସ୍ତୁ ପରିଚାଳନା ନିୟମାବଳୀ 2026' ବିଷୟକ କୁଇଜ୍‌ରେ ସଫଳତାର ସହ ଅଂଶଗ୍ରହଣ କରିଥିବାରୁ ପ୍ରଦାନ କରାଯାଉଛି।",
    bins: ["ଓଦା ବର୍ଜ୍ୟବସ୍ତୁ", "ଶୁଖିଲା ବର୍ଜ୍ୟବସ୍ତୁ", "ସାନିଟାରୀ ବର୍ଜ୍ୟବସ୍ତୁ", "ସ୍ୱତନ୍ତ୍ର ଯତ୍ନ ଆବଶ୍ୟକ କରୁଥିବା ବର୍ଜ୍ୟବସ୍ତୁ"],
  },
  pa: {
    label: "ਪੰਜਾਬੀ (Punjabi)",
    font: '"Noto Sans Gurmukhi", sans-serif',
    kicker: "ਠੋਸ ਰਹਿੰਦ-ਖੂੰਹਦ ਪ੍ਰਬੰਧਨ ਨਿਯਮ, 2026",
    // supplied title "ਭਾਗੀਦਾਰੀ ਸਰਟੀਫਿਕੇਟ", split into the two title lines
    titleMain: "ਸਰਟੀਫਿਕੇਟ",
    titleSub: "ਭਾਗੀਦਾਰੀ",
    text: "ਇਹ ਸਰਟੀਫਿਕੇਟ {name} ਨੂੰ ਮਿਸ਼ਨ ਲਾਈਫ਼ ਲਈ ਈਕੋ ਕਲੱਬ ਦੇ ਤਹਿਤ ਠੋਸ ਰਹਿੰਦ-ਖੂੰਹਦ ਪ੍ਰਬੰਧਨ ਨਿਯਮ, 2026 ਦੇ ਵਿਸ਼ੇ ’ਤੇ ਆਯੋਜਿਤ ਕੁਇਜ਼ ਸਫ਼ਲਤਾਪੂਰਵਕ ਪੂਰਾ ਕਰਨ ਲਈ ਮਾਣ ਸਹਿਤ ਪ੍ਰਦਾਨ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
    bins: ["ਗਿੱਲੀ ਰਹਿੰਦ-ਖੂੰਹਦ", "ਸੁੱਕੀ ਰਹਿੰਦ-ਖੂੰਹਦ", "ਸਫ਼ਾਈ-ਸਬੰਧੀ ਰਹਿੰਦ-ਖੂੰਹਦ", "ਵਿਸ਼ੇਸ਼ ਦੇਖਭਾਲ ਵਾਲੀ ਰਹਿੰਦ-ਖੂੰਹਦ"],
  },
  sa: {
    label: "संस्कृतम् (Sanskrit)",
    font: DEVA,
    kicker: "घनापशिष्ट-प्रबन्धन-नियमाः २०२६",
    // supplied title "भागग्रहणाय प्रमाणपत्रम्", split into the two title lines
    titleMain: "प्रमाणपत्रम्",
    titleSub: "भागग्रहणाय",
    text: "इदं प्रमाणपत्रम् {name} वर्याय 'मिशन लाइफ' योजनायाः 'इको क्लब' - प्रकल्पाधाने 'घनापशिष्ट-प्रबन्धन-नियमाः २०२६' इति विषये आयोजितायाः प्रश्नोत्तर्याः सफलतापूर्वकं पूर्तये सादरं समर्प्यते।",
    // supplied as one phrase "…, विशेष-परिसेवापशिष्टं च" — split per bin, trailing "च" (and) dropped
    bins: ["आर्द्रापशिष्टम्", "शुष्कापशिष्टम्", "मलापशिष्टम्", "विशेष-परिसेवापशिष्टम्"],
  },
  ta: {
    label: "தமிழ் (Tamil)",
    font: '"Noto Sans Tamil", sans-serif',
    kicker: "திடக்கழிவு மேலாண்மை விதிகள் 2026",
    // supplied title "பங்கேற்புச் சான்றிதழ்", split into the two title lines
    titleMain: "சான்றிதழ்",
    titleSub: "பங்கேற்புச்",
    text: "'மிஷன் லைஃப்' திட்டத்தின் கீழ் செயல்படும் 'ஈக்கோ கிளப்' ஏற்பாடு செய்திருந்த 'திடக்கழிவு மேலாண்மை விதிகள் 2026' குறித்த வினாடி-வினா போட்டியை வெற்றிகரமாக நிறைவு செய்ததற்காக, {name} அவர்களுக்கு இச்சான்றிதழ் பெருமையுடன் வழங்கப்படுகிறது.",
    bins: ["ஈரக்கழிவு", "உலர் கழிவு", "சுகாதாரக் கழிவு", "சிறப்புக் கவனத்துடன் கையாள வேண்டிய கழிவு"],
  },
  te: {
    label: "తెలుగు (Telugu)",
    font: '"Noto Sans Telugu", sans-serif',
    kicker: "ఘన వ్యర్థాల నిర్వహణ నియమాలు 2026",
    // supplied title "పాల్గొన్నందుకు ప్రశంసా పత్రం", split into the two title lines
    titleMain: "ప్రశంసా పత్రం",
    titleSub: "పాల్గొన్నందుకు",
    // supplied as two phrases (the "presented to" line + the "for completing" line)
    text: "ఈ ప్రశంసా పత్రం సగర్వంగా {name} గారికి సమర్పించడమైనది. మిషన్ లైఫ్ ఎకో క్లబ్స్ (Eco Clubs for Mission LiFE) ఆధ్వర్యంలో నిర్వహించిన ఘన వ్యర్థాల నిర్వహణ నియమాలు 2026 క్విజ్ పోటీని విజయవంతంగా పూర్తి చేసినందుకు గాను ఈ ప్రశంసా పత్రం అందజేయబడుతోంది.",
    bins: ["తడి వ్యర్థాలు", "పొడి వ్యర్థాలు", "పారిశుధ్య వ్యర్థాలు", "ప్రత్యేక సంరక్షణ వ్యర్థాలు"],
  },
  ur: {
    label: "اردو (Urdu)",
    font: '"Noto Nastaliq Urdu", "Noto Naskh Arabic", serif',
    dir: "rtl",
    kicker: "کچرے کے انتظام کے قواعد 2026",
    // supplied title "شرکت کا سرٹیفکیٹ", split into the two title lines
    titleMain: "سرٹیفکیٹ",
    titleSub: "شرکت کا",
    text: "یہ سرٹیفکیٹ {name} کو مشن لائف کے لیے ایکو کلبز کے زیرِ اہتمام کچرے کے انتظام کے قواعد 2026 کے موضوع پر منعقدہ کوئز کامیابی سے مکمل کرنے پر پیش کیا جاتا ہے۔",
    bins: ["گیلا کچرا", "خشک کچرا", "حفظانِ صحت کا کچرا", "خصوصی نگہداشت والا کچرا"],
  },
};

export const CERT_REGIONAL_LANGS = Object.entries(CERT_REGIONAL).map(([key, v]) => ({ key, label: v.label }));
